import Icon, {IconSize} from '@/components/Icon';
import {FunctionComponent, useCallback, useState} from 'react';

export default function HoverIcon({
    svg,
    hoverSvg,
}: {
    svg: FunctionComponent;
    hoverSvg: FunctionComponent;
}) {
    const [isHover, setIsHover] = useState(false);

    const onEnter = useCallback(() => {
        setIsHover(true);
    }, []);

    const onLeave = useCallback(() => {
        setIsHover(false);
    }, []);

    return (<div onMouseEnter={onEnter} onMouseLeave={onLeave}>
        {
            isHover
                ? <Icon svg={hoverSvg} size={IconSize.LG_PROMAX} />
                : <Icon svg={svg} size={IconSize.LG_PROMAX} />
        }
    </div>);
}
